import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/search_icon.png';
import _imports_1 from '../../../src/assets/img/bookCase.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-ac18f0ba"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "book-index"
};
var _hoisted_2 = {
  class: "headbox"
};
var _hoisted_3 = {
  class: "search"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin-left": "2px",
      "margin-top": "2px"
    }
  }, [/*#__PURE__*/_createElementVNode("img", {
    class: "search_icon",
    src: _imports_0
  })], -1);
});

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    style: {
      "width": "16px",
      "margin-right": "5px"
    }
  }, null, -1);
});

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "我的书架", -1);
});

var _hoisted_7 = [_hoisted_5, _hoisted_6];

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "hr"
  }, null, -1);
});

var _hoisted_9 = {
  class: "category"
};
var _hoisted_10 = {
  class: "swiper-container"
};
var _hoisted_11 = {
  class: "swiper-wrapper"
};
var _hoisted_12 = ["onClick"];
var _hoisted_13 = {
  class: "book_windows"
};
var _hoisted_14 = {
  key: 0,
  class: "book_box"
};
var _hoisted_15 = ["onClick"];
var _hoisted_16 = ["src"];
var _hoisted_17 = {
  class: "book_title"
};
var _hoisted_18 = {
  class: "book_author"
};
var _hoisted_19 = {
  key: 1,
  style: {
    "text-align": "center",
    "margin-top": "81px",
    "color": "#a59c9c"
  }
};

var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "暂无数据...", -1);
});

var _hoisted_21 = [_hoisted_20];
var _hoisted_22 = {
  class: "handle-page"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_input = _resolveComponent("el-input");

  var _component_Head = _resolveComponent("Head");

  var _component_Pagination = _resolveComponent("Pagination");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Head, {
    title: "书架",
    back: false
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
        modelValue: _ctx.searchContent,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _ctx.searchContent = $event;
        }),
        class: "w-50 m-2",
        type: "text",
        placeholder: "搜索你想要的东西"
      }, {
        prefix: _withCtx(function () {
          return [_hoisted_4];
        }),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", {
        class: "search_btn",
        onClick: _cache[1] || (_cache[1] = //@ts-ignore
        function () {
          return _ctx.searchBook && _ctx.searchBook.apply(_ctx, arguments);
        })
      }, " 搜索 ")]), _createElementVNode("div", {
        class: "look-rank",
        onClick: _cache[2] || (_cache[2] = //@ts-ignore
        function () {
          return _ctx.Rank && _ctx.Rank.apply(_ctx, arguments);
        })
      }, _hoisted_7)])];
    }),
    _: 1
  }), _hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
    class: _normalizeClass(["swiper-slide", 0 == _ctx.categoryId ? 'active' : '']),
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return _ctx.changeCategory(0);
    })
  }, " 推荐 ", 2), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.category, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(["swiper-slide", item.typeId == _ctx.categoryId ? 'active' : '']),
      onClick: function onClick($event) {
        return _ctx.changeCategory(item.typeId);
      }
    }, _toDisplayString(item.typeName), 11, _hoisted_12);
  }), 128))])])]), _createElementVNode("div", _hoisted_13, [_ctx.booklist.length != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.booklist, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "flex-col book_item",
      onClick: function onClick($event) {
        return _ctx.toDetail(item);
      }
    }, [item.coverPic ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      class: "book_img",
      src: _ctx.baseurl + item.coverPic,
      alt: "",
      mode: "aspectFill"
    }, null, 8, _hoisted_16)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_17, _toDisplayString(item.bookName), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(item.author), 1)], 8, _hoisted_15);
  }), 128))])) : _createCommentVNode("", true), _ctx.booklist.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_22, [_ctx.booklist.length != 0 ? (_openBlock(), _createBlock(_component_Pagination, {
    key: 0,
    pagesize: 12,
    "total-num": _ctx.bookNum,
    onChangPage: _ctx.changPage
  }, null, 8, ["total-num", "onChangPage"])) : _createCommentVNode("", true)])])]);
}